import styled, { keyframes } from "styled-components";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";

export const tokens = {
  radius: 12,
  spacing: 8,
  elevation: "0 6px 18px rgba(16,24,40,0.08)",
  border: "1px solid rgba(0,0,0,0.08)",
  bgCard: "#FAFAFA",
  brand: "#f58220",
  brandTextOn: "#ffffff",
  focus: "#4F46E5",
  textMuted: "rgba(0,0,0,0.6)",
  textStrong: "rgba(0,0,0,0.9)",
  transition: "180ms cubic-bezier(0.2, 0, 0, 1)",
};

const enter = keyframes`
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    border-radius: ${tokens.radius}px;
    box-shadow: ${tokens.elevation};
    border: ${tokens.border};
    overflow: visible;
    animation: ${enter} ${tokens.transition};
  }
  & .MuiDialogContent-root {
    overflow: visible;
  }
`;

export const ModalTitleBar = styled.div`
  display: flex;
  align-items: flex-start;
  padding: ${tokens.spacing * 2}px ${tokens.spacing * 3}px;
  gap: ${tokens.spacing}px;
`;

export const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing / 2}px;
`;

export const SummaryCard = styled.div`
  background: ${tokens.bgCard};
  border: ${tokens.border};
  border-radius: ${tokens.radius}px;
  padding: ${tokens.spacing * 2}px;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing * 1.5}px;
  & + & {
    margin-top: ${tokens.spacing * 1.25}px;
  }
`;

export const SummaryLabel = styled.span`
  min-width: 120px;
  color: ${tokens.textMuted};
  font-size: 0.875rem;
`;

export const SummaryValue = styled.span`
  color: ${tokens.textStrong};
  font-weight: 600;
`;

export const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${tokens.spacing * 1.5}px;
  padding: ${tokens.spacing * 1.5}px ${tokens.spacing * 3}px
    ${tokens.spacing * 2}px;
  border-top: ${tokens.border};
`;

export const PrimaryButton = styled(Button)`
  &.MuiButton-root {
    background: ${tokens.brand};
    color: ${tokens.brandTextOn};
    border-radius: ${tokens.radius - 4}px;
    text-transform: none;
    font-weight: 700;
    transition: transform ${tokens.transition}, filter ${tokens.transition},
      box-shadow ${tokens.transition};
  }
  &.MuiButton-root:hover {
    filter: brightness(0.95);
  }
  &.MuiButton-root:active {
    transform: translateY(1px);
    filter: brightness(0.9);
  }
  &.MuiButton-root:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.35);
  }
  &.MuiButton-root:disabled {
    background: #9e9e9e;
    color: #ffffff;
    opacity: 0.6;
  }
`;

export const SecondaryButton = styled(Button)`
  &.MuiButton-root {
    border-color: rgba(0, 0, 0, 0.2);
    color: ${tokens.textStrong};
    border-radius: ${tokens.radius - 4}px;
    text-transform: none;
    font-weight: 700;
    transition: background ${tokens.transition},
      border-color ${tokens.transition}, box-shadow ${tokens.transition};
  }
  &.MuiButton-root:hover {
    background: rgba(0, 0, 0, 0.04);
  }
  &.MuiButton-root:active {
    background: rgba(0, 0, 0, 0.08);
  }
  &.MuiButton-root:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.35);
  }
`;
